module.exports = __webpack_public_path__ + "static/media/thumb_2.2229f0ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_2.png
// module id = 78
// module chunks = 0